import {MenuFormat, PrintMode} from "lib/api/pdfGenerator";
import { AperitifPresetValues } from "lib/api/aperitifMenu";

export type {MenuFormat, PrintMode};
export type MenuPage = MenuItem[]

export interface MenuDocument {
    type: 'wine' | 'leaflet' | 'label' | 'aperitif'
    language: 'de' | 'fr' | 'it'
    format: MenuFormat;
    coverPage: CoverPage | null
    printMode: PrintMode
    showAppellation: boolean
    showYear: boolean
    degu: boolean
    displayFooter: boolean
    pages: MenuPage[]
    sizes: DocumentDrinkSizes
}

export function hasFormatEditor(type: MenuDocument['type']) {
    return type === 'wine' ||type === 'aperitif'
}

export interface CoverPage {
    variant?: '1' | '2' | '3'
    title: string
    coverImageUrl: string
    logoImageUrl: string | null
}

export const DRINK_SIZES = ["Flasche", "5dl", "3dl", "2.5dl", "2dl", "1dl"] as const;
export type DrinkSize = (typeof DRINK_SIZES)[number];
export type DocumentDrinkSizes = [DrinkSize, DrinkSize, DrinkSize, DrinkSize];
export type DocumentDrinkSizesIndex = 0 | 1 | 2 | 3;

export interface MenuItem {
    type: 'pageTitle' | 'title' | 'margin' | 'pagebreak' | 'image' | 'wine' | 'label' | 'aperitif'
}

export interface PageTitleItem extends MenuItem {
    type: 'pageTitle'
    title: string
}

export function isPageTitleItem(item: MenuItem): item is PageTitleItem {
    return item.type === 'pageTitle';
}

export interface TitleItem extends MenuItem {
    type: 'title'
    title: string
    sizes: DrinkSize[]
}

export function isTitleItem(item: MenuItem): item is TitleItem {
    return item.type === 'title';
}

export interface MarginItem extends MenuItem {
    type: 'margin'
    height: number
}

export function isMarginItem(item: MenuItem): item is MarginItem {
    return item.type === 'margin';
}

export interface PageBreakItem extends MenuItem {
    type: 'pagebreak'
}

export function isPageBreakItem(item: MenuItem): item is PageBreakItem {
    return item.type === 'pagebreak';
}

export interface ImageItem extends MenuItem {
    type: 'image'
    align?: 'start' | 'center' | 'end'
    url: string
    height: number
}

export function isImageItem(item: MenuItem): item is ImageItem {
    return item.type === 'image';
}

export type WineBadge = 'seasonal' | 'bio' | 'bestSeller' | 'housewine' | 'wineOfMonth';

export interface WineItem extends MenuItem {
    type: 'wine'
    external: boolean
    objectID: string | null | undefined
    detailed: boolean
    showDescription: boolean
    country: string | null | undefined
    img_url: string | null | undefined
    img_scale?: number | null | undefined
    name: string
    title?: string
    year: number | null | undefined
    size: number | null | undefined
    region: string
    producer: string
    grapes: string
    text: string
    showTasteSweetness?: boolean | null | undefined
    taste: number | null | undefined
    sweetness: number | null | undefined
    showSuitableFood?: boolean | null | undefined
    suitableFood: string
    badges: WineBadge[]
    prices: (number | null)[]
    displayPrices: (number | null)[]
    purchasePricePerBottle: number | null
    showAppellation?: boolean
    showYear?: boolean
    appellation?: string | null
}

export function isWineItem(item: MenuItem): item is WineItem {
    return item.type === 'wine';
}

export interface AperitifItem extends MenuItem, AperitifPresetValues {
    type: 'aperitif'
    presetId: string | null | undefined
}

export function isAperitifItem(item: MenuItem): item is AperitifItem {
    return item.type === 'aperitif';
}

export const MAX_WINE_NAME_LENGTH = 40;

export function getMaxWineTextLength(format: MenuFormat) {
    if (format === 'a6') {
        return 190;
    }
    return 170;
}
